module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image46.4fa17e76.jpg";